import Vue from 'vue'
import http from '@/http'
import { filter, flow, map, each, union } from 'lodash/fp'

const ttl = 5000
const dictionaries = {}
const now = () => new Date().getTime()

export function createDictionary({
  resource,
  idAttribute = 'id',
  parseResponse = res => res.data
}) {
  // create ttl struct
  dictionaries[resource] = {}
  dictionaries[resource].expired = 0

  return {
    namespaced: true,

    state: () => ({
      list: [],
      entities: {},
      isLoading: false
    }),

    mutations: {
      setLoading(state, status) {
        state.isLoading = status
      },

      setEntities(state, entities) {
        let ids = []

        each(x => {
          let id = x[idAttribute].toString()
          Vue.set(state.entities, id, x)
          ids.push(id)
        })(entities)

        state.list = union(state.list, ids)
      }
    },

    getters: {
      isLoading(state) {
        return state.isLoading
      },

      list(state) {
        return map(x => state.entities[x])(state.list)
      },

      filterList: state => identity => {
        return flow(
          map(x => state.entities[x]),
          filter(identity)
        )(state.list)
      },

      byId: state => id => {
        return state.entities[id]
      }
    },

    actions: {
      async fetch({ commit }, params) {
        if (now() < dictionaries[resource].expired) return

        commit('setLoading', true)
        dictionaries[resource].expired = now() + ttl

        try {
          const response = await http.get(`${resource}`, { params })
          commit('setEntities', parseResponse(response))
        } catch (error) {
          throw error
        }

        dictionaries[resource].expired = now() + ttl

        commit('setLoading', false)
      }
    }
  }
}
